import { getApiCcofPracticeIdAppointments } from "@/lib/api-client/endpoints/ccof-appointments/ccof-appointments";
import {
  TokenPagedResult,
  useTokenPagedInfiniteQuery,
} from "@/lib/query/useTokenPagedInfiniteQuery";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import type { AppointmentSummary } from "lib/api-types/schemas";
import { PAGE_SIZE } from "@/lib/query/constants";
import type { CardCollectionRow } from "../types";
import appointmentToRowAdapter from "../utils/appointmentToRowAdapter";

export const cardCollectionQueryKey = (
  practiceId: string,
  hasCard?: boolean | null,
) => ["card-collection", "appointments", practiceId, hasCard] as const;

export type CardCollectionPagedResult = TokenPagedResult<
  CardCollectionRow,
  {
    summary?: AppointmentSummary;
  }
>;

async function fetchCardCollectionPage(
  practiceId: string,
  hasCard?: boolean,
  nextToken?: string,
): Promise<CardCollectionPagedResult> {
  const res = await getApiCcofPracticeIdAppointments(practiceId, {
    pageSize: PAGE_SIZE,
    nextToken,
    hasCard,
  });

  return {
    items: (res.data.items ?? []).map(appointmentToRowAdapter),
    nextToken: res.data.nextToken,
    extra: {
      summary: res.data.summary,
    },
  };
}

interface Props {
  hasCard?: boolean;
}

export function useCardCollection({ hasCard }: Props) {
  const { tenantId } = useTenantRouteContext();

  return useTokenPagedInfiniteQuery({
    queryKey: cardCollectionQueryKey(tenantId, hasCard),
    fetchPage: (nextToken) =>
      fetchCardCollectionPage(tenantId, hasCard, nextToken),
  });
}
